// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","header_box":"Header_header_box__rr+4c","logo_img":"Header_logo_img__kiDps","profile_img":"Header_profile_img__H5kXN","name":"Header_name__slxgR"};